import { IconButton, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

import {
  TableContent,
  TableContentItemLabel,
  TableContentItemText,
} from '../../../../components/TableContent';
import { TableContentItemStatus } from '../../../../components/TableContent/status';
import { messageError } from '../../../../store/batchTicket/constants';

import { ResponsiveItemCustomerProps } from '.';

export const TabletItemTable: React.FC<ResponsiveItemCustomerProps> = ({
  item,
  detailsButtonIsDisabled,
  handlePressDetailsButton,
  detailsButtonColor,
}) => {
  return (
    <TableContent direction="row">
      <VStack space={Spacing['inline.nano']} w="full">
        <HStack alignItems="center" justifyContent="space-between">
          <TableContentItemText
            variant="semibold"
            color="neutral.black"
            fontSize={Typography['fontsize.lg']}>
            {item.basketOrderHash || messageError}
          </TableContentItemText>
          <TableContentItemStatus basketAdvisorStatus={item.basketAdvisorStatus} />
        </HStack>
        <HStack justifyContent="space-between" alignItems="center">
          <VStack space={Spacing['stack.quarck']}>
            <TableContentItemLabel>Data de criação</TableContentItemLabel>
            <TableContentItemText>{item.createDateFormatted}</TableContentItemText>
          </VStack>
          <VStack space={Spacing['stack.quarck']}>
            <TableContentItemLabel>Tipo</TableContentItemLabel>
            <TableContentItemText>{item.applicationType}</TableContentItemText>
          </VStack>
          <VStack space={Spacing['stack.quarck']}>
            <TableContentItemLabel>Clientes</TableContentItemLabel>
            <TableContentItemText>{item.totalCustomers}</TableContentItemText>
          </VStack>
          <VStack space={Spacing['stack.quarck']}>
            <TableContentItemLabel>Ativos</TableContentItemLabel>
            <TableContentItemText>{item.totalOffers}</TableContentItemText>
          </VStack>
          <VStack space={Spacing['stack.quarck']}>
            <TableContentItemLabel>Total Investido</TableContentItemLabel>
            <TableContentItemText>{item.totalRequestedAmountFormatted}</TableContentItemText>
          </VStack>
          <VStack space={Spacing['stack.quarck']}>
            <TableContentItemLabel>Ult. atualização</TableContentItemLabel>
            <TableContentItemText>{item.updateDateFormatted}</TableContentItemText>
          </VStack>
          <IconButton
            isDisabled={detailsButtonIsDisabled}
            onPress={handlePressDetailsButton}
            testId="arrow-right"
            icon="ArrowRight"
            iconColor={Color[detailsButtonColor]}
          />
        </HStack>
      </VStack>
    </TableContent>
  );
};
